import { render, staticRenderFns } from "./SignUpFive.vue?vue&type=template&id=0e2511f7"
import script from "./SignUpFive.vue?vue&type=script&lang=js"
export * from "./SignUpFive.vue?vue&type=script&lang=js"
import style0 from "./SignUpFive.vue?vue&type=style&index=0&id=0e2511f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports